import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const TrendMakers = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "trendmakers_logo.png" }) {
        childImageSharp {
          fixed(quality: 80, width: 150) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return (
    <Img
      fixed={data.placeholderImage.childImageSharp.fixed}
      backgroundColor="transparent"
      loading="eager"
    />
  )
}

export default TrendMakers
